<template>
  <b-modal
    id="addingStageModal"
    title="Добавление этапа"
    ref="addingStageModal"
    header-bg-variant="primary"
    header-text-variant="light"
    ok-title="Добавить"
    cancel-title="Отмена"
    ok-variant="primary"
    cancel-variant="outline-primary"
    @ok="onAddStep"
    :ok-disabled="okDisabled"
  >
    <div class="mt-2">Название этапа</div>
    <b-form-input
      class="mt-2"
      v-model="newStageTitle"
      placeholder="Введите название"
    ></b-form-input>
    <b-form-invalid-feedback :force-show="Boolean(titleError)">
      {{ titleError }}
    </b-form-invalid-feedback>
    <b-form-checkbox class="mt-2" v-model="isUnexpected"
      >Нештатная ситуация</b-form-checkbox
    >
    <div class="mt-2">Этап для начала</div>
    <b-form-select
      class="mt-2"
      :disabled="!isUnexpected"
      v-model="stageForStart"
      :options="stages"
    ></b-form-select>
    <b-form-invalid-feedback
      :force-show="isUnexpected && stageForStart === null"
    >
      Для нештатной ситуации нужно выбрать этап для начала
    </b-form-invalid-feedback>
    <div class="mt-2">Шаг для начала</div>
    <b-form-select
      class="mt-2"
      :disabled="!isUnexpected || stageForStart === null"
      v-model="stepForStart"
      :options="stepsForStart"
    ></b-form-select>
    <b-form-invalid-feedback
      :force-show="isUnexpected && stepForStart === null"
    >
      Для нештатной ситуации нужно выбрать шаг для начала
    </b-form-invalid-feedback>
    <div class="mt-2">Шаг для окончания</div>
    <b-form-select
      class="mt-2"
      :disabled="!isUnexpected || stageForStart === null"
      v-model="stepForEnd"
      :options="stepsForEnd"
    ></b-form-select>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

function initialState() {
  return {
    newStageTitle: 'Новый этап',
    isUnexpected: false,
    stageForStart: null,
    stepForStart: null,
    stepForEnd: null,
    usedStageNames: null,
    titleError: null
  }
}

export default {
  name: 'AddingStageModal',
  data() {
    return initialState()
  },
  mounted() {
    this.usedStageNames = new Set(this.course.stages.map((stage) => stage.name))
  },
  computed: {
    ...mapGetters({
      course: 'training/getTrainingCourse'
    }),
    stages() {
      return this.course.stages
        .filter((stage) => !stage.stageName)
        .map((stage) => ({
          text: `${stage.name}`,
          value: `${stage.name}`
        }))
    },
    selectedStage() {
      return this.course.stages.find(
        (stage) => stage.name === this.stageForStart,
      )
    },
    stepsForStart() {
      if (this.selectedStage) {
        return this.selectedStage.steps.map((steps) => steps.id)
      }
      return []
    },
    stepsForEnd() {
      return [{ value: null, text: '' }, ...this.stepsForStart]
    },
    okDisabled() {
      return (
        this.newStageTitle.length === 0
        || (this.isUnexpected
          && (this.stageForStart === null || this.stepForStart === null))
      )
    }
  },
  methods: {
    ...mapActions({
      updateUpdater: 'contentManager/updateUpdater'
    }),
    onAddStep() {
      if (this.isUnexpected) {
        this.course.addUnexpectedStage(
          this.newStageTitle,
          this.stageForStart,
          Number(this.stepForStart),
          this.stepForEnd !== null ? Number(this.stepForEnd) : null,
        )
      } else {
        this.course.addStage(this.newStageTitle)
      }
      this.updateUpdater()
      Object.assign(this.$data, initialState())
    }
  },
  watch: {
    newStageTitle(newTitle) {
      this.titleError = null
      if (newTitle.length === 0) {
        this.titleError = 'Имя этапа не может быть пустым'
      }
      if (this.usedStageNames && this.usedStageNames.has(newTitle)) {
        this.titleError = 'Такой этап уже существует'
      }
    }
  }
}
</script>

<style scoped></style>
